/* Casa M Spice Co® — buy box Direction A behavior (claude.ai/design 2026-06-11)
   SJL-171 companion. Native selling plans only: sets <input name="selling_plan">,
   updates ATC copy ("ADD TO CART · $X" / "START SUBSCRIPTION $X/delivery"), renders
   the caption, hides itself on variants with no allocations. Variant tracking via a
   light poll on the form's select[name=id] (Impulse updates it programmatically). */

(function () {
  'use strict';

  // Single-init guard: the snippet emits this <script> once per subscribable
  // card (up to 12 in The Lineup grid). Only the first execution sets up the
  // scan + interval; the rest bail. scan() is document-wide, so one instance
  // still inits every [data-cc-po] on the page. (Safe on the PDP — loads once.)
  if (window.__ccbbInit) return;
  window.__ccbbInit = 1;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function init(po) {
    if (po.dataset.ccInit) return;
    po.dataset.ccInit = '1';

    var form = po.closest('form');
    if (!form) return;
    var sel = form.querySelector('select[name="id"]');
    var spInput = po.querySelector('[data-cc-selling-plan]');
    var rowOnce = po.querySelector('[data-cc-row="once"]');
    var rowSub = po.querySelector('[data-cc-row="sub"]');
    var freqs = po.querySelector('[data-cc-freqs]');
    // Acq preview 2026-07-22: benefits stack + strike price (deal framing)
    var benefits = po.querySelector('[data-cc-benefits]');
    var strike = po.querySelector('[data-cc-strike]');
    var atcSpan = form.querySelector('[data-add-to-cart-text]');
    var allocs;
    try { allocs = JSON.parse(po.querySelector('[data-cc-alloc]').textContent); }
    catch (e) { return; }

    var caption = document.createElement('div');
    caption.className = 'cc-po__caption';
    var anchor = form.querySelector('.payment-buttons') || form.querySelector('[data-add-to-cart]');
    if (anchor) anchor.insertAdjacentElement('afterend', caption);

    var subOnly = po.dataset.ccSubOnly === '1';
    var mode = subOnly ? 'sub' : 'once';
    var chipOn = freqs.querySelector('.cc-po__chip.is-on') || freqs.querySelector('.cc-po__chip');
    var planId = chipOn ? chipOn.dataset.ccPlanId : null;
    var lastVid = null;

    function curVariant() { return (sel && allocs[sel.value]) || null; }
    // Sale cents for a variant, read off the server-rendered sale span that
    // snippets/casam-sale-price.liquid emits, and only while that span's own
    // window is open. The window is re-checked through window.CasamSale so the
    // button obeys the same clock as every other sale surface — a cached page
    // cannot leave a sale price on the CTA after ends_at. No sale span, no
    // window, or no cents => null, and the caller keeps the regular price.
    function saleCents(vid) {
      if (!vid) return null;
      try {
        var el = document.querySelector('[data-cm-sale-cents][data-cm-sale-vid="' + String(vid).replace(/"/g, '') + '"]');
        if (!el) return null;
        var s = +el.getAttribute('data-cm-sale-start') || 0;
        var e = +el.getAttribute('data-cm-sale-end') || 0;
        var live = (window.CasamSale && window.CasamSale.isLive)
          ? window.CasamSale.isLive(s, e)
          : (e > 0 && Date.now() / 1000 >= s && Date.now() / 1000 <= e);
        if (!live) return null;
        var c = +el.getAttribute('data-cm-sale-cents');
        return c > 0 ? c : null;
      } catch (err) { return null; }
    }
    function subCents(v) {
      // audit #18: price the SELECTED plan only. Falling back to some other
      // plan's price showed a figure that didn't match the selling_plan the
      // form actually submits. If the selected plan isn't allocated for this
      // variant, there is no sub price to show.
      if (!v || !v.s) return null;
      return v.s[planId] != null ? v.s[planId] : null;
    }
    function freqLabel() {
      var on = freqs.querySelector('.cc-po__chip.is-on');
      return on ? on.textContent.trim() : 'Every month';
    }

    function render() {
      var v = curVariant();
      var eligible = !!(v && Object.keys(v.s).length);
      po.classList.toggle('cc-po--hidden', !eligible);
      caption.hidden = !eligible;
      if (!eligible && mode === 'sub' && !subOnly) mode = 'once';

      if (v) {
        // The One-time row quotes the same live sale price as the CTA; the Subscribe
        // row keeps the regular figures (the automatics exclude selling_plan lines).
        var onceEl = po.querySelector('[data-cc-once-price]');
        var onceSale = saleCents(sel && sel.value);
        if (onceEl) onceEl.textContent = money(onceSale != null ? onceSale : v.p);
        var sc = subCents(v);
        if (sc != null) po.querySelector('[data-cc-sub-price]').textContent = money(sc);
        // Strike shows the one-time price only when it actually beats the sub price
        if (strike) {
          strike.textContent = money(v.p);
          strike.hidden = !(sc != null && sc < v.p);
        }
      }

      if (rowOnce) {
        rowOnce.classList.toggle('is-on', mode === 'once');
        rowOnce.setAttribute('aria-pressed', mode === 'once');
      }
      rowSub.classList.toggle('is-on', mode === 'sub');
      rowSub.setAttribute('aria-pressed', mode === 'sub');
      freqs.hidden = mode !== 'sub';
      if (benefits) benefits.hidden = mode !== 'sub';
      // audit #16: never submit an empty selling_plan for an eligible sub variant.
      // Use the selected plan when it's allocated for this variant, else fall back
      // to the first plan the variant actually supports (a requires-selling-plan
      // product would otherwise be rejected by Shopify at Add-to-Cart).
      var effPlan = '';
      if (mode === 'sub' && v && v.s) {
        effPlan = (v.s[planId] != null) ? planId : (Object.keys(v.s)[0] || '');
      }
      spInput.value = effPlan;

      if (atcSpan && v && v.a && !/sold out|unavailable/i.test(atcSpan.textContent)) {
        // audit #17: only show the subscription label when the selected plan
        // actually has a price; otherwise money(null) rendered "$0.00/delivery".
        var _sc = mode === 'sub' ? subCents(v) : null;
        // Spine-scheduled sale (custom.storefront_sale_prices): this span is the
        // ONLY writer of the CTA's price, so without this the price block read
        // "Sale price $67.49" while the button under it still said $134.99.
        // ONE-TIME ONLY on purpose — the projected promos are one_time_only and
        // their automatics exclude selling_plan lines, so a subscription CTA
        // must keep quoting the subscription price.
        var _sale = mode === 'sub' ? null : saleCents(sel && sel.value);
        var want = (mode === 'sub' && _sc != null)
          ? 'Start Subscription · ' + money(_sc) + '/delivery'
          : (atcSpan.dataset.defaultText || 'Add to cart') + ' · ' + money(_sale != null ? _sale : v.p);
        if (atcSpan.textContent.trim() !== want) atcSpan.textContent = want;
      }

      caption.classList.toggle('cc-po__caption--sub', mode === 'sub');
      caption.textContent = mode === 'sub'
        ? 'Delivers ' + freqLabel().toLowerCase() + ' · 10% off every delivery · skip or cancel anytime'
        : 'One-time purchase — no subscription';
    }

    if (rowOnce) rowOnce.addEventListener('click', function () { mode = 'once'; render(); });
    rowSub.addEventListener('click', function () { mode = 'sub'; render(); });
    freqs.addEventListener('click', function (e) {
      var chip = e.target.closest('.cc-po__chip');
      if (!chip) return;
      freqs.querySelectorAll('.cc-po__chip').forEach(function (c) { c.classList.remove('is-on'); });
      chip.classList.add('is-on');
      planId = chip.dataset.ccPlanId;
      render();
    });
    form.addEventListener('change', function () { window.requestAnimationFrame(render); });

    setInterval(function () {
      var vid = sel && sel.value;
      if (vid !== lastVid) { lastVid = vid; render(); }
    }, 350);

    render();
  }

  function scan() {
    document.querySelectorAll('[data-cc-po]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  setInterval(scan, 1500);
})();
